import { useTranslation } from 'react-i18next'

import { FunnelSimpleIcon, XIcon } from '@phosphor-icons/react'

import { Button } from '@reveni-io/reveni-ui'

import QueryFilter from '@/common/components/QueryFilter/QueryFilter'
import SelectedFilters from '@/common/components/SelectedFilters/SelectedFilters'
import useFiltersModal from '@/common/hooks/useFiltersModal/useFiltersModal'

import FiltersModal from './FiltersModal/FiltersModal'
import { filterNames } from './constants'
import * as Styles from './styles'

const Filters = ({ query, filters, setFilters, regions, queryFilterPlaceholder, source, carriers }) => {
  const { t } = useTranslation()
  const { showFiltersModal, onCloseFiltersModal, selectedFilter, onOpenFiltersModal, onClickInFilterChip } =
    useFiltersModal()

  const shouldShowClearFiltersButton = filters => Object.keys(filters).length > 0

  const handleChangeFilter = (filterName, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: value,
    }))
  }

  const handleDeleteFilter = filterName => {
    setFilters(prevFilters => {
      const { [filterName]: _, ...rest } = prevFilters
      return rest
    })
  }

  const handleClearFilters = () => {
    setFilters({})
  }

  return (
    <>
      <Styles.Container>
        <Styles.HeaderContainer>
          <Styles.LeftFiltersContainer>
            <QueryFilter
              placeholder={queryFilterPlaceholder || t('Nombre')}
              defaultValue={query}
              onChange={query => handleChangeFilter(filterNames.query, query)}
              onChangeValue={query => handleChangeFilter(filterNames.query, query)}
            />
            <Button variant="text" size="s" onClick={onOpenFiltersModal}>
              <FunnelSimpleIcon size={24} weight="light" />
              {t('Añadir filtro')}
            </Button>
            {shouldShowClearFiltersButton(filters) && (
              <Button variant="text" size="s" onClick={handleClearFilters}>
                <XIcon size={24} weight="light" />
                {t('Limpiar filtros')}
              </Button>
            )}
          </Styles.LeftFiltersContainer>
        </Styles.HeaderContainer>
        <SelectedFilters
          filters={filters}
          regions={regions}
          carriers={carriers}
          onDeleteFilter={handleDeleteFilter}
          onClickFilter={onClickInFilterChip}
        />
      </Styles.Container>
      <FiltersModal
        show={showFiltersModal}
        onClose={onCloseFiltersModal}
        onChangeFilter={handleChangeFilter}
        filters={filters}
        preselectedFilterType={selectedFilter}
        regions={regions}
        source={source}
        carriers={carriers}
      />
    </>
  )
}

export default Filters
